export const apiField = 'wind_speed';
import { isMetricUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';
import { note as windSpeedNote } from 'projectDesign/components/projectConfiguration/fieldsTooltips/windSpeedVerifyNote';

interface WindSpeedField {
  type: string;
  apiField: string;
  label: string;
  note: any;
  min: number;
  max: number;
  verifyLinkNote?: boolean;
  missing?: any;
  disable?: boolean;
  isAurora?: boolean;
}

function makeConfig(max: number = 180, min: number = 85, label:string= 'windSpeed', verifyLinkNote:boolean= true, isAurora: boolean = false, isOs: boolean = false, showFMGNote: boolean = false): WindSpeedField {
  return {
    type: 'Number',
    label,
    apiField,
    note: {
      message: windSpeedNote(showFMGNote),
      shouldShow: verifyLinkNote,
    },
    min,
    max,
    missing: undefined,
    disable: isAurora,
    labelClassName: 'label-height-16',
  };
}

const mphToKmph = (mph: number) =>  mph * 1.60934; //1 mile = 1.60934 kilometers

const config = (maxWindSpeed: number,showFMGNote: boolean = false) => makeConfig(maxWindSpeed, 85, 'windSpeed', true, false, showFMGNote);

export default config;

export const asce705WindSpeedForSfmAndSm = (isAurora: boolean = false, isOs: boolean = false) => {return makeConfig(180, 85, 'windSpeed', true, isAurora, isOs)};

export const asce710WindSpeedForSfmAndSm = (isAurora: boolean = false, isOs: boolean = false) => {return makeConfig(190, 95, 'windSpeed', true, isAurora, isOs)};

export const asce716WindSpeedForSfmAndSm_nxt = (isAurora: boolean = false, isOs: boolean = false) => {return makeConfig(190, 85, 'windSpeed', true, isAurora, isOs);};

export const asce716WindSpeedForSfmAndSm =  makeConfig(190);

export const asce705WindSpeedForSmTilt = (windSpped) => makeConfig(windSpped);

export const asce716WindSpeedMetric = (showFMGNote: boolean, metricMaxWindSpeed?: number) => makeConfig((metricMaxWindSpeed ? metricMaxWindSpeed : 266), 136, 'windSpeed.kph', true, false, showFMGNote);

export const asce7107And716WindSpeedForGft = makeConfig(165);

export const asce7107And716WindSpeedForUla = makeConfig(165);

export const getWindSpeedField = (inputUnit: number, showFMGNote: boolean = false, maxWindSpeed: number) =>  isMetricUnit(inputUnit) ? asce716WindSpeedMetric(showFMGNote, mphToKmph(maxWindSpeed)) : config(maxWindSpeed, showFMGNote);
